import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Cliente, ClienteKpis, InvitarLoteResult } from '../../shared/models/system';
import { SpringPage } from '../../shared/models/page';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

@Injectable({ providedIn: 'root' })
export class ClientesService {
  private apiUrl = `${environment.apiUrl}/clientes`;

  constructor(private http: HttpClient, private auth: Auth) {}

  private getHeaders() {
    const token = this.auth.getToken();
    return {
      headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` })
    };
  }

  getAll(page = 0, size = 10, q?: string, active?: boolean): Observable<SpringPage<Cliente>> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size));
    if (q?.trim()) params = params.set('q', q.trim());
    if (active !== undefined && active !== null) params = params.set('active', String(active));
    return this.http.get<SpringPage<Cliente>>(`${this.apiUrl}`, { params, ...this.getHeaders() });
  }

  getActive(): Observable<Cliente[]> {
    return this.http.get<Cliente[]>(`${this.apiUrl}/active`, this.getHeaders());
  }

  getKpis(): Observable<ClienteKpis> {
    return this.http.get<ClienteKpis>(`${this.apiUrl}/kpis`, this.getHeaders());
  }

  create(cliente: Partial<Cliente>): Observable<Cliente> {
    return this.http.post<Cliente>(`${this.apiUrl}`, cliente, this.getHeaders());
  }

  update(id: number, cliente: Partial<Cliente>): Observable<Cliente> {
    return this.http.put<Cliente>(`${this.apiUrl}/${id}`, cliente, this.getHeaders());
  }

  toggle(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, this.getHeaders());
  }

  invitar(id: number): Observable<Cliente> {
    return this.http.post<Cliente>(`${this.apiUrl}/${id}/invitar`, {}, this.getHeaders());
  }

  invitarLote(): Observable<InvitarLoteResult> {
    return this.http.post<InvitarLoteResult>(`${this.apiUrl}/invitar-lote`, {}, this.getHeaders());
  }
}
